export default "__VITE_ASSET__CJGWD3or__"